(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeFoodDietsController', TypeFoodDietsController);

    TypeFoodDietsController.$inject = ['GenericEntityDatatableService', 'CoreService', 'TypeFoodDiets', '$uibModal',
        'ConfirmationService', '$q'];

    function TypeFoodDietsController(GenericEntityDatatableService, CoreService, TypeFoodDiets, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Food Diets',
            newButtonTitle: 'New Food Diet',
            entityClassHumanized: 'Food Diets',
            entityStateName: 'type-food-diets',
            service: TypeFoodDiets,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Food Diet',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-food-diets/update/type-food-diets-dialog.html',
                controller: 'TypeFoodDietsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-food-diets/update/type-food-diets-dialog.html',
                controller: 'TypeFoodDietsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeFoodDiets', function (TypeFoodDiets) {
                        return TypeFoodDiets.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('TypeFoodDiets').result.then(function () {
                    TypeFoodDiets.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
